var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.$route.meta.hideNavigation)?_c('v-app-bar',{attrs:{"app":"","color":"oug","dark":"","dense":""}},[_c('v-toolbar-title',[_vm._v("\n     "+_vm._s(new Date().getFullYear())+" - "+_vm._s(_vm.Title)+"\n  ")]),_c('v-spacer')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }